import {useReversalService} from '../../service/reversal/index'

const useGetBase64= () => {
    const {getReversalBase64} = useReversalService()
  const getData64 = async (id:string, encriptograph: string) => {
     const api = await getReversalBase64(id, encriptograph)

     return api
  };
  return {
    getData64,
  };
};

export default useGetBase64;
